<template style="height:100%">
  <div class="Activity_communication">
    <el-form :inline="true" :model="formInline" class="demo-form-inline">


      <el-form-item label="举办日期11：">
        <el-date-picker v-model="EventDate" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
      </el-form-item>
    </el-form>

    <div class="nav">

      <el-table :data="tableData" style="width:98%;margin-left:1%;padding-top:15px;">
        <el-table-column prop="date"    label="日期"></el-table-column>
        <el-table-column prop="name"    label="姓名"></el-table-column>
        <el-table-column prop="address" label="地址"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination style="margin-top:20px;text-align:right" @current-change="handleCurrentChange1" :page-size="pageSize" layout="total, prev, pager, next" :total="Count"></el-pagination>
    </div>

    <el-dialog title="提示" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
      <div style="height: 500px;text-align: -webkit-center;">

        <div v-if="pdpm34 == 1" style="width: 500px;height: 300px;">
          <img style="width: 100%;height: 100%;" src="https://img2.baidu.com/it/u=1028011339,1319212411&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=313" alt="">
        </div>

        <div v-else-if="pdpm34 == 2" style="width: 500px;height: 300px;">
          <video width="100%" height="100%" controls>
            <source src="" type="video/mp4">
            <source src="" type="video/ogg">
            您的浏览器不支持Video标签。
          </video>
        </div>

      </div>
    </el-dialog>

  </div>
</template>
<script>
  export default {
    data() {
      return {
        EventDate:[],
        dialogVisible:false,
        pdpm34:1,
        formInline: {
          user: '',
          region: '',
          value1: '',
        },
        tableData: [{
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        }, {
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1517 弄'
        }, {
          date: '2016-05-01',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1519 弄'
        }, {
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1516 弄'
        }],
        pageIndex:1,
        pageSize:10,
        Count:0,
      };
    },
    components:{

    },
    methods: {
      handleClick(row){
        this.dialogVisible = true;
      },

  
      convertGMTToDate(gmtDate) {
          const date = new Date(gmtDate);
          return date.toISOString().split('T')[0]; // 返回 "YYYY-MM-DD" 格式的字符串
      },

      onSubmit() {
        console.log(  this.convertGMTToDate(this.EventDate[0]))
        console.log(this.EventDate[1])

        // let splittedWeeks = this.splitByWeek(this.EventDate[0], this.EventDate[1]);

        // console.log(splittedWeeks)
      },

      splitByWeek(start, end) {
        console.log(start)
        console.log(end)
        let current = new Date(start);
        let result = [];
      
        // 保证当前是星期一
        while (current.getDay() !== 1) {
          current.setDate(current.getDate() + 1);
        }
      
        while (current < end) {
          // 当前星期一
          let startOfWeek = new Date(current);
          // 下个星期日
          let endOfWeek = new Date(current);
          endOfWeek.setDate(endOfWeek.getDate() + 6);
          // 如果下个星期日超出了结束时间，则设置为结束时间
          if (endOfWeek > end) {
            endOfWeek = new Date(end);
          }
          result.push({ start: startOfWeek, end: endOfWeek });
          // 移动到下个星期一
          current.setDate(current.getDate() + 7);
        }
      
        return result;
      },



      handleCurrentChange1(val) {
        this.pageIndex = val;
      },
      handleClose(done) {
        this.$confirm('确认关闭？').then(_ => {
          done();
        })
        .catch(_ => {});
      }
    },
    mounted(){
      // console.log(this.splitByWeek(this.EventDate[0], this.EventDate[1]))
      
    }
  };
</script>

<style>
  .Activity_communication {height: 100%;}
  .Activity_communication .demo-form-inline{padding: 15px;background-color: #fff;}
  .Activity_communication .nav{height: calc(100% - 110px);background-color: #fff;margin-top: 15px;}
</style>